module.exports = __webpack_public_path__ + "static/Wildlife_Build_My_Book-838524c9782b492d463eec6483b6f7cc.jpg";